export const calculateTotalPages = (totalItemsCount, itemsPerPage) => {
    //Returns a rounded up value of total pages needed according to total items count and items per page
    return Math.ceil(totalItemsCount / itemsPerPage);
}

export const calculateInRangePage = (totalItemsCount, itemsPerPage, pageNumber) => {
    //Calculate the initial page taking into account minimum and 
    // maximum pages according to the total items count and items per page
    //if pageNumber is below the minimum it will correct to the minimum, and vica versa.

    let totalPages = calculateTotalPages(totalItemsCount, itemsPerPage);
    let currentPageToUse = pageNumber;
    if (currentPageToUse > totalPages) {
        currentPageToUse = totalPages;
    }
    if (currentPageToUse < 1) {
        currentPageToUse = 1;
    }

    return currentPageToUse;
}

export const calculatePageChange = (totalItemsCount, itemsPerPage, currentPage, pageClicked) => {
    //Calculate the page number to navigate to when a page is clicked.  
    // This will handle previous and next page button and account for minimum and maximum pages that can be returned.
    
    let returnPage;
    
    switch (pageClicked.toUpperCase()) { 
        case "PREVIOUS":
            returnPage = currentPage - 1;
            break;
        case "NEXT":
            returnPage = currentPage + 1;
            break;
        default:         
            //if not previous or next it will be a page number
            returnPage = parseInt(pageClicked);
            break;
    }

    let totalPages = calculateTotalPages(totalItemsCount, itemsPerPage);

    if (returnPage > totalPages) {
        returnPage = totalPages;
    }
    if (returnPage < 1) {
        returnPage = 1;
    }
    
    return returnPage;
}

export const calculateSliceStartingPoint = (itemsPerPage, currentPage) => {
    let pageIndex = parseInt(currentPage) - 1;
    if (pageIndex <= 0){
        return 0;
    }

    return pageIndex * parseInt(itemsPerPage);
}

export const calculateSliceEndingPoint = (itemsPerPage, currentPage, totalItemCount) => {    
    let pageIndex = parseInt(currentPage) - 1;
    let itemsPerPageNumber = parseInt(itemsPerPage);
    let totalItemCountNumber = parseInt(totalItemCount);
    
    if (pageIndex <= 0){
        if (totalItemCountNumber <= itemsPerPageNumber){
            return totalItemCountNumber;
        }        
        return itemsPerPageNumber;
    }
    
    if (itemsPerPageNumber == 0)
        return 0;
    
    let endPoint = (pageIndex * itemsPerPageNumber) + itemsPerPageNumber;
    if (endPoint >= totalItemCountNumber)
        return totalItemCountNumber;
    
    return endPoint;
}